export default function ClarksvilleDestinationsSection() {
  const destinations = [
    {
      city: "Germany",
      flag: "🇩🇪",
      reason: "Military Bases",
      detail: "Stuttgart, Grafenwoehr, and Ramstein are common destinations for Fort Campbell soldiers and their families.",
      flight: "10-12 hrs from BNA",
    },
    {
      city: "South Korea",
      flag: "🇰🇷",
      reason: "Korea Rotation",
      detail: "The 101st Airborne frequently rotates to Korea. We understand the SOFA stamp requirements for military dependents.",
      flight: "14-16 hrs from BNA",
    },
    {
      city: "Japan",
      flag: "🇯🇵",
      reason: "OCONUS Assignments",
      detail: "Okinawa and mainland Japan are common PCS destinations. We handle all dependent passport needs for military families.",
      flight: "14-16 hrs from BNA",
    },
    {
      city: "Mexico",
      flag: "🇲🇽",
      reason: "R&R Leave",
      detail: "Popular for military R&R leave. Cancun, Riviera Maya, and Puerto Vallarta are top destinations for Fort Campbell families.",
      flight: "3-4 hrs from BNA",
    },
    {
      city: "Italy",
      flag: "🇮🇹",
      reason: "Europe PCS",
      detail: "Vicenza and other European bases welcome military families. We handle passport and visa documentation for Italy.",
      flight: "10-12 hrs from BNA",
    },
    {
      city: "United Kingdom",
      flag: "🇬🇧",
      reason: "NATO Assignments",
      detail: "London and Mildenhall are common duty stations. We assist with UK entry requirements for military dependents.",
      flight: "8-9 hrs from BNA",
    },
  ];

  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Clarksville Travelers Go
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From military installations to vacation destinations, we prepare passports for every journey from Fort Campbell.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((dest, index) => (
            <div key={index} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-[#F6C344] transition-all">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-3xl">{dest.flag}</span>
                <div>
                  <h3 className="font-serif text-lg font-bold text-[#1A365D]">{dest.city}</h3>
                  <span className="text-[#F6C344] text-xs font-semibold uppercase">{dest.reason}</span>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{dest.detail}</p>
              <div className="flex items-center gap-2 text-xs text-gray-400 bg-[#F7F8FA] px-3 py-2 rounded-lg">
                <i className="ri-flight-takeoff-line"></i>
                <span>{dest.flight}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}